import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAdvisor } from '@/components/feature/AdvisorProvider';
import { trackContact } from '@/hooks/usePixel';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { whatsapp, wapp } = useAdvisor();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 80);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Inicio', href: '#hero' },
    { label: 'Servicios', href: '#servicios' },
    { label: 'Nosotros', href: '#nosotros' },
    { label: 'Equipo', href: '#equipo' },
    { label: 'Proyectos', href: '#proyectos' },
    { label: 'Testimonios', href: '#testimonios' },
    { label: 'Contacto', href: '#contacto' },
  ];

  const scrollToSection = (href: string) => {
    setMobileOpen(false);
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-aa-black/90 backdrop-blur-md border-b border-aa-gold/10'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link
            to="/"
            className="flex items-center gap-3 hover:opacity-90 transition-opacity"
          >
            <img
              src="https://static.readdy.ai/image/ea473d33d180c87428df5c28ba90939d/22de7431a9e08c77d04732633a5e622a.png"
              alt="Alianza Andina Empresarial"
              className="h-14 md:h-20 w-auto object-contain"
            />
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <button
                key={link.href}
                onClick={() => scrollToSection(link.href)}
                className="text-sm text-aa-gray-100 hover:text-aa-gold transition-colors duration-300 gold-underline whitespace-nowrap cursor-pointer"
              >
                {link.label}
              </button>
            ))}
            <a
              href={wapp}
              target="_blank"
              rel="noopener noreferrer"
              onClick={trackContact}
              className="flex items-center gap-2 bg-aa-gold text-aa-black px-5 py-2.5 rounded-full text-sm font-semibold hover:shadow-gold-glow transition-all duration-300 whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-base" />
              WhatsApp
            </a>
          </div>

          {/* Mobile Hamburger */}
          <button
            className="md:hidden text-white w-10 h-10 flex items-center justify-center"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-2xl`} />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden absolute top-full left-0 right-0 bg-aa-black/95 backdrop-blur-lg border-b border-aa-gold/10 transition-all duration-300 overflow-hidden ${
          mobileOpen ? 'max-h-[400px] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-6 py-6 flex flex-col gap-4">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => scrollToSection(link.href)}
              className="text-left text-aa-gray-100 hover:text-aa-gold transition-colors py-2 text-sm whitespace-nowrap"
            >
              {link.label}
            </button>
          ))}
          <a
            href={wapp}
            target="_blank"
            rel="noopener noreferrer"
            onClick={trackContact}
            className="flex items-center gap-2 bg-aa-gold text-aa-black px-5 py-3 rounded-full text-sm font-semibold mt-2 w-fit whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-base" />
            WhatsApp
          </a>
        </div>
      </div>
    </nav>
  );
}